module.exports = __webpack_public_path__ + "app-static/img/p_01.fc8189b4.jpg";